import _ from 'underscore';
import classNames from 'classnames';
import React, { useContext, useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'react-jss';
import { ComponentSettings, ThemeFluent } from '@bingads-webui-theme-2018/theme-fluent';
import { DoubleListBox, DoubleListBoxContextProvider, DoubleListBoxContext } from '@bingads-webui-react/double-list-box-fluent';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getStyles } from './get-styles';

const DataSource = ({ genreOptions }) => {
  const {
    state: {
      search,
    },
    dispatch,
  } = useContext(DoubleListBoxContext);

  useEffect(() => {
    dispatch({ type: 'START_LOAD_DATA' });

    const items = search ? genreOptions.filter(item => item.name.toLowerCase().includes(search.toLowerCase())) : genreOptions;
    const start = 0;
    const end = items.length;
    dispatch({
      type: 'FINISH_LOAD_DATA',
      payload: {
        items: items.slice(start, end),
        totalCount: items.length,
      },
    });
  }, [dispatch, search, genreOptions]);

  return null;
};

DataSource.propTypes = {
  genreOptions: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  })).isRequired,
};

const UnthemedGenreSelectionDoubleListBox = ({
  onSelectionChange, i18n, genreOptions, genreTargets, classes,
}) => {
  const selectedItems = useMemo(
    () => _.map(genreTargets, genreTarget => _.findWhere(genreOptions, { id: genreTarget }))
    , [genreTargets, genreOptions]
  );

  return (
    <ThemeProvider theme={{ components: ComponentSettings, core: ThemeFluent }}>
      <div className="gerne-selection-container" style={{ display: 'flex', marginTop: 5 }}>
        <DoubleListBoxContextProvider
          initialSelectedItems={selectedItems}
        >
          <DataSource
            i18n={i18n}
            genreOptions={genreOptions}
          />
          <DoubleListBox
            onSelectionChange={onSelectionChange}
            className={classNames(classes.doubleListBox, 'genre-double-list-box')}
            availableItemsText={i18n.getString(_TL_('All genres'))}
          />
        </DoubleListBoxContextProvider>
      </div>
    </ThemeProvider>
  );
};

UnthemedGenreSelectionDoubleListBox.propTypes = {
  classes: PropTypes.shape(_.mapObject(getStyles(), _.constant(PropTypes.string.isRequired)))
    .isRequired,
  onSelectionChange: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  genreOptions: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
  })).isRequired,
  genreTargets: PropTypes.arrayOf(PropTypes.number).isRequired,
};

const GenreSelectionDoubleListBox = withDefaultStyles(UnthemedGenreSelectionDoubleListBox, getStyles);

export { GenreSelectionDoubleListBox };
